import { resolveTheme } from './resolveTheme.js';
import { THEME_STORAGE_KEY } from './readThemePreference.js';

const SYSTEM_DARK_QUERY = '(prefers-color-scheme: dark)';

/**
 * Saves the preference and draws the resolved theme on the root element
 * (data-theme="light" or "dark"), where tokens.css picks it up.
 */
export const applyThemePreference = ({ preference, persist = true }) => {
  const systemPrefersDark = window.matchMedia?.(SYSTEM_DARK_QUERY).matches ?? false;
  const theme = resolveTheme({ preference, systemPrefersDark });
  document.documentElement.dataset.theme = theme;
  document.documentElement.dataset.themePreference = preference;
  if (persist) {
    try {
      window.localStorage.setItem(THEME_STORAGE_KEY, preference);
    } catch {
      // Storage can be unavailable (private mode); the theme still applies for this visit.
    }
  }
  return theme;
};
